export default __webpack_public_path__ + "SurveyFormatting_AA.html";